<template>
<div class="chapter">
<div class="inner_page">
<h1>Tarzan</h1>
<h2 class="sigil_not_in_toc">und die Weisse Frau</h2>
<h2 class="sigil_not_in_toc">Edgar Rice Burroughs</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?c8cc76d0